import ApiService from '../api-service'
import { accountResponse, VerifyCodeData, VerifyCodeResponse } from './interface'

export const verifyCode = (data : VerifyCodeData) => ApiService.post<VerifyCodeData, Promise<VerifyCodeResponse>>('/auth/login', {
  data,
  authorized: false
})

export const account = () => ApiService.get<undefined, Promise<accountResponse>>('/account', {})
